export const SELECT_TAB = 'WORKS/TABS/SELECT';
export const TOGGLE_VAT = 'WORKS/TOGGLE_VAT';

export const OPEN_INTERVENTION_UPDATE_MODAL = 'WORKS/MODALS/OPEN_INTERVENTION_UPDATE';
export const CLOSE_INTERVENTION_UPDATE_MODAL = 'WORKS/MODALS/CLOSE_INTERVENTION_UPDATE';

export const SET_SELECTED_GROUP_OFFER = 'WORKS/OFFERS/SET_SELECTED_GROUP_OFFER';

export const OPEN_APPOINTMENT_BOOKING_MODAL = 'WORKS/MODALS/OPEN_APPOINTMENT_BOOKING_MODAL';
export const CLOSE_APPOINTMENT_BOOKING_MODAL = 'WORKS/MODALS/CLOSE_APPOINTMENT_BOOKING_MODAL';
